module.exports = __webpack_public_path__ + "static/media/Google_play_symbol_2x.e1357a93.png";